var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"customMain"},[_c('BackOnTop',{attrs:{"title":"集點辦法"}}),_c('div',{staticClass:"info_wrappper",staticStyle:{"padding":"16px 32px"}},[_c('p',{staticStyle:{"text-align":"left"},attrs:{"id":"editor_pet"},domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }